import React, { useState } from "react";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";

export default function DeactivateAccountModal({ show, onClose, user }) {
  const [confirmText, setConfirmText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [error, setError] = useState("");

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (confirmText !== "DELETE") {
      setError('Please type DELETE to confirm.');
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.delete(
        `${ApiConnectionString}/api/account`,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      if (response.status === 200) {
        setIsComplete(true);
      } else {
        setError("Unable to deactivate account. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setError("Unable to deactivate account. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setError("");
    setIsComplete(false);
    setConfirmText("");
    onClose();
  };

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title brand-purple">
                {isComplete ? "Account deactivated" : "Deactivate account"}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              ></button>
            </div>

            {isComplete ? (
              <div className="modal-body text-center py-4">
                <div className="alert alert-success mb-4">
                  Your account has been deactivated.
                </div>

                <p className="text-muted mb-4">
                  Any active subscriptions linked to this account will be cancelled.
                  You can now close this window.
                </p>

                <button
                  className="btn brand-purple-inline"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            ) : (
              <div className="modal-body">
                {error && <div className="alert alert-danger">{error}</div>}

                <div className="alert alert-warning">
                  When you deactivate your account you will lose access to your
                  data and websites linked to this account. Any active
                  subscriptions for your websites will be cancelled.
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label fw-semibold brand-purple">
                      Type DELETE to confirm
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={confirmText}
                      onChange={(e) => setConfirmText(e.target.value)}
                    />
                  </div>

                  <div className="modal-footer px-0">
                    <button
                      type="button"
                      className="btn brand-purple-outline"
                      onClick={handleClose}
                      disabled={isLoading}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className="btn btn-danger"
                      disabled={isLoading}
                    >
                      {isLoading ? "Deactivating..." : "Deactivate account"}
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
}
